import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { NotFoundComponent } from '../components/not-found/not-found.component';
import { ConsentRequestsComponent } from './consent-requests/consent-requests.component';
import { ConsentChecklistsComponent } from './consent-checklists/consent-checklists.component';
import { ConsentApprovalsComponent } from './consent-approvals/consent-approvals.component';

const routes: Routes = [
  {
    path: 'consents',
    component: SideNavComponent,
    children: [
      {
        path: 'requests',
        component: ConsentRequestsComponent,
        data: { tab: 'requests', icon: 'approval', title: 'Consent Requests' },
      },
      {
        path: 'checklists',
        component: ConsentChecklistsComponent,
        data: { tab: 'checklists', icon: 'checklist' },
      },
      {
        path: 'investors',
        component: ConsentApprovalsComponent,
        data: { tab: 'investors', icon: 'how_to_vote' },
      },
      {
        path: '',
        redirectTo: '/consents/requests',
        pathMatch: 'full',
      },
      {
        path: '**',
        component: NotFoundComponent,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConsentsRoutingModule {}
